import { CurrencyDetails } from "./currency-details";
import { TaxItem } from './tax-item';
import { OperatorPurchaseOffer } from './operator-purchase-offer';

export class FlightPriceBreakdown {
  bookingRate: number;
  operatorPriceInSelectedCurrency: number;
  operatorPriceInBillingCurrency: number;
  flightPriceInSelectedCurrency: number;
  flightPriceInBillingCurrency: number;
  commissionInSelectedCurrency: number;
  commissionInBillingCurrency: number;
  transactionFeeInSelectedCurrency: number;
  transactionFeeInBillingCurrency: number;
  guaranteedRecoveryFeeInSelectedCurrency: number;
  guaranteedRecoveryFeeInBillingCurrency: number;
  partnerCommissionFeeInSelectedCurrency: number;
  partnerCommissionFeeInBillingCurrency: number;
  specialRate: boolean;
  currencyDetails: CurrencyDetails;
  taxesInBillingCurrency: Array<TaxItem> = [];
  customerPriceTotalInBillingCurrency: number;

  static fromPurchaseOffer(
    offer: OperatorPurchaseOffer,
    flightPriceInBillingCurrency: number,
    isRtpFlow: boolean
  ): FlightPriceBreakdown {
    const feeOrZero = (fee: number): number => (isRtpFlow ? 0 : fee);
    const breakdown = new FlightPriceBreakdown();
    breakdown.operatorPriceInSelectedCurrency = offer.offerPriceInCurrency;
    breakdown.operatorPriceInBillingCurrency = offer.offerPrice;
    breakdown.flightPriceInSelectedCurrency = offer.flightPriceInCurrency;
    breakdown.flightPriceInBillingCurrency = flightPriceInBillingCurrency;
    breakdown.commissionInSelectedCurrency = feeOrZero(offer.commissionInCurrency);
    breakdown.commissionInBillingCurrency = feeOrZero(offer.commission);
    breakdown.transactionFeeInSelectedCurrency = feeOrZero(offer.transactionFeeInCurrency);
    breakdown.transactionFeeInBillingCurrency = feeOrZero(offer.transactionFee);
    breakdown.guaranteedRecoveryFeeInSelectedCurrency = feeOrZero(
      offer.guaranteedRecoveryFeeInCurrency
    );
    breakdown.guaranteedRecoveryFeeInBillingCurrency = feeOrZero(offer.guaranteedRecoveryFee);
    breakdown.partnerCommissionFeeInSelectedCurrency = feeOrZero(
      offer.partnerCommissionFeeInCurrency
    );
    breakdown.partnerCommissionFeeInBillingCurrency = feeOrZero(offer.partnerCommissionFee);
    const savedBookingRate = offer.brokerRate != null ? offer.brokerRate * 100 : null;
    breakdown.bookingRate = isRtpFlow ? 0 : savedBookingRate;
    breakdown.specialRate = isRtpFlow || flightPriceInBillingCurrency != null;
    breakdown.taxesInBillingCurrency = offer.getTaxes();
    breakdown.customerPriceTotalInBillingCurrency =
      offer.getTotalFlightPrice() ?? (isRtpFlow ? flightPriceInBillingCurrency : null);
    return breakdown;
  }
}
